import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_ORIGIN } from "@/config";
import { useI18n } from "@/i18n";

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setAlternate = (hreflang, href) => {
  let el = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setMetaProp = (prop, content) => {
  let el = document.head.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Injects per-route hreflang alternates (sk / en / x-default), canonical and
// og:locale metadata. Slovak is the default; English is available via ?lang=en.
export const SeoHreflang = () => {
  const { pathname } = useLocation();
  const { lang } = useI18n();

  useEffect(() => {
    const base = SITE_ORIGIN + pathname;
    const skUrl = base;
    const enUrl = `${base}?lang=en`;

    setAlternate("sk", skUrl);
    setAlternate("en", enUrl);
    setAlternate("x-default", skUrl);

    setCanonical(lang === "en" ? enUrl : skUrl);
    setMetaProp("og:url", lang === "en" ? enUrl : skUrl);
    setMetaProp("og:locale", lang === "en" ? "en_US" : "sk_SK");
    setMetaProp("og:locale:alternate", lang === "en" ? "sk_SK" : "en_US");
  }, [pathname, lang]);

  return null;
};
